import { useCallback } from 'react';
import { useGetVoucherContractConfigsQuery, useUpdateVoucherContractConfigMutation } from '../services/benefitApi';
import { useDeductionLineConfig } from './useDeductionLineConfig';
export function useVoucherContractConfig(voucherContractId, enabled) {
    const query = useGetVoucherContractConfigsQuery({ voucherContractId: voucherContractId ?? '' }, { skip: !voucherContractId || !enabled, refetchOnMountOrArgChange: true });
    const [updateConfig, { isLoading: isSaving }] = useUpdateVoucherContractConfigMutation();
    const persist = useCallback(async (config, nextIsEnabled) => {
        await updateConfig({
            voucherContractId: voucherContractId ?? '',
            configId: config.id,
            isEnable: nextIsEnabled,
        }).unwrap();
    }, [updateConfig, voucherContractId]);
    return useDeductionLineConfig({
        query,
        isSaving,
        enabled,
        canPersist: Boolean(voucherContractId),
        persist,
    });
}
